import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import ReactSelect from "react-select";
import styled from "styled-components";
import { extractStylingProps } from "../../shared/propStyling/propStylingUtils";
import { useTombac } from "../../shared/tombac";
import { reactSelectStyles } from "./Select/reactSelectStyles";
import { reactSelectTheme } from "./Select/reactSelectTheme";
import { selectCss } from "./Select/selectCss";
function UnstyledSelect(props) {
  const tombac = useTombac();
  const [_, nonStylingProps] = extractStylingProps(props);
  return /*#__PURE__*/React.createElement(ReactSelect, _extends({
    isSearchable: false,
    placeholder: "",
    theme: reactSelectTheme(tombac),
    styles: reactSelectStyles(tombac)
  }, nonStylingProps));
}
export const Select = styled(UnstyledSelect).attrs(() => ({
  className: "TombacSelect"
})).withConfig({
  displayName: "Select"
})(["", ""], selectCss);
//# sourceMappingURL=Select.js.map